<template>
    <div class="overflow-hidden border border-gray-300 rounded-md">
        <div class="flex items-center bg-gray-100">
            <div class="w-2/12 py-2 px-2 font-bold">Код</div>
            <div class="w-2/12 py-2 font-bold">Минимальная сумма</div>
            <div class="w-2/12 py-2 font-bold">Количество заказов</div>
            <div class="w-2/12 py-2 font-bold">Скидка (%)</div>
            <div class="w-2/12 py-2 font-bold">Скидка (р.)</div>
            <div class="w-2/12 py-2 font-bold">Тип доставки</div>
            <div class="w-1/12 py-2 font-bold">Для новых</div>
            <div class="w-1/12 py-2 font-bold">Активен</div>
        </div>

        <div
            v-for="item in list"
            :key="item.id"
            class="flex items-center h-10 py-4 border-t border-gray-300"
        >
            <div class="w-2/12 truncate px-2">
                <span
                    class="text-purple-700 cursor-pointer hover:underline"
                    :title="item.title"
                    @click="$emit('select', item.id)"
                >
                    {{ item.code }}
                </span>
            </div>

            <div class="w-2/12 py-2">{{ item.min_sum }} р.</div>
            <div class="w-2/12 py-2">{{ item.term_count }}</div>
            <div class="w-2/12 py-2">{{ item.discount_percent }}%</div>
            <div class="w-2/12 py-2">{{ item.discount_sum }}р.</div>

            <div class="w-2/12 py-2">
                    {{ labelDeliveryType(item.delivery_type) }}
            </div>

            <div class="w-1/12">
                <CBadge :color="item.enabled ? 'success' : 'secondary'">
                    {{ item.enabled ? "Да" : "Нет" }}
                </CBadge>
            </div>
        </div>
    </div>
</template>

<script>
    const { formatDate } = require('../../utils/views');
    const { DELIVERY_TYPE } = require('../../utils/order');

    export default {
        components: {},

        props: {
            list: {
                type: Array,
                default: () => [],
            },
        },

        data: () => ({}),

        computed: {},

        methods: {
            labelDeliveryType (delivery_type) {
                const types = [];
                types.push({ value: DELIVERY_TYPE.DOOR, label: 'До двери' });
                types.push({ value: DELIVERY_TYPE.MEETING_POINT, label: 'Место встречи' });
                types.push({ value: DELIVERY_TYPE.WITHOUT, label: 'Без доставки' });
                types.push({ value: DELIVERY_TYPE.COLLECT, label: 'Сборка заказа' });

                for (const type of types) {
                    if(delivery_type === type.value){
                        return type.label;
                    }
                }
                return '';
            },

            formatDate(date) {
                return formatDate(date);
            },
        },
    };
</script>
